import { Replanificacion } from "components/UsuarioGeneral/Vacaciones/Solicitud Vacaciones/TypesSolicitudVacaciones"

export const ID_SOLICITUD_JUSTIFICACION_NO_MARCACION = 41; 
export const ID_SOLICITUD_RECUPERACION_MARCACION = 42;

export type SolicitudesPorAprobar =  {
    nombres:string,
    fechaSolicitud:Date,
    diaOrdinario:number,
    diasPendientesVacaciones?:number,
    diasRestantesVacaciones?:number,
    fechaDesde:Date,
    fechaHasta:Date,
    fechaVencimiento:Date,
    estado:number,
    estadoString:string,
    horaDesde: string,
    horaHasta: string,
    horasTotal:string,
    idregimenlaboral:number,
    idSolicitud:number,
    tipoSolicitud:string,
    estadoParse:string,
    observacion:string,
    acciones: PropAcciones,
    idContrato:number,
    aprueba:string // Indica si al directivo, aprueba parcial o totalmente, "S" significa que se aprueba totalmente y "N" que es aprobacion parcial
    cantidadAprueba:number,
    apruebanAmbos:string,
    fechaReintegro?:Date,
    permisoCargoVacaciones:boolean,
    idTipoPermiso?:number,
    subTipo: string,
    subTipoDescripcion:string
}

export type PropAcciones = {
    tiposolicitud:string,
    estado:number,
    estadoParse:string,
    idSolicitud:number,
    aprueba:string,
    cantidadAprueba:number,
    apruebanAmbos:string,
    fechaDesde:Date,
    fechaHasta:Date,
    fechaSolicitud:Date,
    fechaVencimiento:Date,
    diaOrdinario:number,
    diasPendientes?:number,
    nuevoSaldo?:number,
    nombres:string,
    observacion:string,
    fechaReintegro?:Date,
    estadoString:string,
    permisoCargoVacaciones:boolean,
    idTipoPermiso?:number,
    subTipo:string,
    horaDesde: string,
    horaHasta: string,
    subTipoDescripcion: string
}

export enum EstadoSolicitudVacaciones {
    INGRESO = 1,
    APROBACIONUNIDAD = 2,
    APROBACIONRRHH = 3,
    NEGADOUNIDAD = 4,               //NO SE APRUEBA SOLICITUD
    NEGADORRHH = 5,                 //DESPUES DE APROBADA POR UNIDAD, SE NIEGA SOLICITUD
    ANULADO = 6,                    //ANULADA POR TRABAJADOR
    REVERSORRHH = 7,                //REVERSO TH
    REVERSOUNIDAD = 8,              //SOLICITUD APROBADA Y UNIDAD PIDE REVERSO
    ANULADARRHH = 9,                //SOLICITUD APROBADA Y TH ANULA SOLICITUD
    INVALIDARRHH = 10,              //SOLICITUD APROBADA, INVALIDA TH
    MODIFICADARRHHNUEVA = 11,       //SOLICITUD APROBADA, MODIFICADA TH, NUEVA SOLICITUD
    APROBACIONPARCIALUNIDAD = 12 ,
    INGRESOSINDOCUMENTO = 13
}

export enum EstadoSolicitudReintegro {
    INGRESADA = "P",
    APROBACIONDIRECTIVO = "E",
    APROBACIONTH ="A",
    ANULADO = "I"
}

export enum EstadoSolicitudReplanificacionVacaciones {
    INGRESO = 1,
    APROBADA = 2,
    NEGADA = 3,
    ANULADA = 4,
    APROBADA_PARCIALMENTE = 5
}

export enum TipoSolicitud {
   
    TIPO_MARCACION = "JUSTIFICACIÓN POR NO MARCACIÓN",
    TIPO_RECUPERACION = "RECUPERACIÓN DE TIEMPO NO LABORADO"
} 

export type SolicitudVacacionesRechazoDTO  = {
    Observacion:string
}

export type PostSolicitudMasivo = {
    idsolicitud:number,
    tipo:string,
    aprueba:string
    
}

export enum TipoFiltroSolicitudAprobar {
    TODOS = "TO",
    MARCACIONES_VENCIDAS = "VE"

}


export type DetalleSolicitudReplanificacion = {
    listadoPlanificacionesAnteriores:Replanificacion[],
    listadoReplanificaciones:Replanificacion[],
    listadoNoEjecutadas:Replanificacion[],
    nombres:string,
    fechaSolicitud:Date,
    justificacionNoEjecutadas:string
}

export enum EstadoSolicitudJustificacion {
    INGRESO = "P",
    APROBACIONUNIDAD = "J",
    APROBACIONRRHH = "A",
    APROBACIONPARCIALUNIDAD = "L",
    NEGADOUNIDAD="O"
}

export enum EstadoSolicitudGestion {
    INGRESO = "IN",
    APROBACIONUNIDAD = "AD",
    APROBACIONRRHH = "A",
    APROBACIONPARCIALUNIDAD = "AP",
    NEGADOUNIDAD="DN"
}